/**
 * The origin every `signIn` callback URL is built on: `publicUrl` from
 * `useRuntimeConfig()`. The current origin is only a fallback for an unset
 * `AUTH_URL`; relying on it pins the customer to whichever host they arrived
 * on, which is what splits the IdP round-trip across two origins.
 */
export const getPublicOrigin = (publicUrl: string | undefined): string =>
	publicUrl ?? window.location.origin;

/** An absolute URL on the public origin for an in-app path. */
export const buildPublicUrl = (
	path: string,
	publicUrl: string | undefined
): string => new URL(path, getPublicOrigin(publicUrl)).toString();
